import { mapGetters } from "vuex";
import { isEmpty, isUndefined } from "lodash-es";

import MixinBillable from "@Mixins/billable";

export default {
  mixins: [MixinBillable],

  computed: {
    ...mapGetters(["isAccountUsageEnabled"]),

    limitsList() {
      return ["aliases_per_billing_month", "hits_per_billing_month"];
    },

    hasAnyLimit() {
      return this.limitsList.some((limitName) => this.hasLimit(limitName));
    },
  },

  methods: {
    /**
     * Perform a check if the user is allowed to use overages.
     */
    canOverage(name) {
      if (isEmpty(this.billable)) return false;
      return !isUndefined(this.billable.limits.overage[name]);
    },

    /**
     * Perform a check if there is an overages.
     */
    hasOverage(name) {
      return this.getOverageQuantity(name) > 0;
    },

    /**
     * Perform a check if an overages is being used or enabled.
     */
    isOverageOn(name) {
      if (isEmpty(this.billable)) return false;
      return this.billable.limits.overage[name] === true;
    },

    getOverageQuantity(name) {
      const overageQuantity = this.getLimitUsedCredits(name) - this.getLimitMaximumCredits(name);
      return overageQuantity > 0 ? overageQuantity : 0;
    },

    getOveragePrice(name) {
      const OVERAGE_PRICE_PER_LINKS = 0.02;
      const OVERAGE_UNIT_SIZE_FOR_HITS = 1000;
      const OVERAGE_COUNT = this.getOverageQuantity(name);

      const FEE_HITS_PER_BILLING_MONTH = Math.ceil(OVERAGE_COUNT / OVERAGE_UNIT_SIZE_FOR_HITS);
      const FEE_ALIASES_PER_BILLING_MONTH = OVERAGE_COUNT * OVERAGE_PRICE_PER_LINKS;

      if (name === "aliases_per_billing_month") {
        return FEE_ALIASES_PER_BILLING_MONTH;
      } else if (name === "hits_per_billing_month") {
        return FEE_HITS_PER_BILLING_MONTH;
      }
    },

    getLimitUsedCredits(name) {
      if (isEmpty(this.billable)) return 0;
      return this.billable.limits.used[name];
    },

    getLimitMaximumCredits(name) {
      if (isEmpty(this.billable)) return 0;
      return this.billable.limits.limit[name];
    },

    getSoftLimit(name) {
      if (isEmpty(this.billable)) return null;
      return this.billable.limits.soft_limit[name];
    },

    hasLimit(name) {
      return this.getLimitMaximumCredits(name) !== null;
    },

    hasLimitReached(value, max) {
      if (max === null) return false;
      return value >= max;
    },

    isRestricted(name) {
      return this.getLimitMaximumCredits(name) === 0;
    },

    getClassColor(reached) {
      return reached ? "text-danger" : "text-success";
    },

    getPercent(value, max, round = true) {
      if (max === null) return 0;
      if (max === 0) return 100;
      if (value === 0) return 0;

      const percent = (value / max) * 100;
      return round ? Math.round(percent) : percent;
    },
  },
};
